import axios from './axios'
import bus from './bus'
import cookies from './cookies'
import currency from 'v-currency-field'
import moment from 'moment'
import lodash from 'lodash'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import 'v-currency-field/dist/index.css'

let instaled = false

// Plugin install
const install = Vue => {
    if (instaled) return // Plugin já foi instalado

    Object.defineProperties(Vue.prototype, {
        $http: {
            get() {
                return axios
            },
        },
        $bus: {
            get() {
                return bus
            },
        },
        $cookies: {
            get() {
                return cookies
            },
        },
        $moment: {
            get() {
                moment.locale('pt-br')
                return moment
            },
        },
        $lodash: {
            get() {
                return lodash
            },
        },
    })

    Vue.use(Chartkick.use(Chart))
    Vue.use(VueReCaptcha, {
        siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA,
        loaderOptions: {
            autoHideBadge: true,
        },
    })

    Vue.use(currency)

    instaled = true
}

export default install
